import React, { useState } from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import { surveyOptions, optionBtn, optionBtnActive as optionBtnActiveClass } from "./survey-answer-question-card.module.scss";

export interface ISurveyAnswerSelectProps {
    question: ISurveyQuestion;
    value: string | number | null;
    onChange: (value: string | number) => void;
    onSave?: (value: string | number, shouldClose?: boolean) => void;
}

const SurveyAnswerSelect: React.FC<ISurveyAnswerSelectProps> = ({
    question,
    value,
    onChange,
    onSave,
}) => {
    const { options } = question;

    const handleOptionClick = (optionId: number | string) => {
        onChange(optionId);
        // if (onSave) {
        //     onSave(optionId, false); // false = nie zamykaj pytania
        // }
    };

    return (
        <div className={surveyOptions}>
            {options &&
                options.map((option) => {
                    const optionId = (option.id ?? option.value) as string | number;
                    if (optionId === undefined) return null;
                    const isActive = optionId == value;
                    return (
                        <button
                            key={optionId}
                            type="button"
                            className={`${optionBtn} ${isActive ? optionBtnActiveClass : ""}`}
                            onClick={() => handleOptionClick(optionId)}
                            data-value={option.label}
                        >
                            {option.label}
                        </button>
                    );
                })}
        </div>
    );
};

export default SurveyAnswerSelect;
